import { EcsActionType } from "../actions";
import { diffConfiguration } from "./diffConfiguration";
export function configurationReducer(state = null, action) {
    switch (action.type) {
        case EcsActionType.ReplaceConfiguration:
            return diffConfiguration(state, action.payload);
        case EcsActionType.ResetAll:
            return null;
        default:
            return state;
    }
}
//# sourceMappingURL=configurationReducer.js.map